import * as React from 'react';
import { Main } from '../layouts/main';
import { ContactUs } from '../components/contact-us';
import { FindUs } from '../components/find-us';

export default function KontaktPage(): React.ReactNode {
  return (
    <Main title="Advocare - Kontakt z kancelarią">
      <ContactUs />
      <FindUs />
    </Main>
  );
}
